import { useParams } from '@tanstack/react-router';
import { ActivityLog } from './ActivityLog.tsx';

/**
 * Message Activity Log of the whole environment (BB-105): every campaign, Canvas and test send in the log window. A
 * campaign's or Canvas' own log is a tab of its analytics.
 */
export function ActivityLogPage() {
  const { environmentId } = useParams({ from: '/env/$environmentId/analytics/activity-log' });
  return (
    <section>
      <h1>Message activity log</h1>
      <ActivityLog environmentId={environmentId} heading="h2" />
    </section>
  );
}
